module.exports = __webpack_public_path__ + "static/img/SANCO.36e0b671.png";